export { IconProvider, type IconProviderProps, useIconRegistry } from "./IconContext";
export { iconNames, type IconName } from "./icon-names";
export { iconRegistry } from "./icon-registry";
export { type IconRegistry, type SvgIconComponent, type SvgIconProps } from "./IconRegistry";
